
export default [
  // Drop Specials
  {
    path: '/dashboard/drop-specials',
    name: 'DropSpecialList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Drop/Specials/SpecialListView.vue')
  },
  {
    path: '/dashboard/drop-specials/create',
    name: 'DropSpecialCreate',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Drop/Specials/SpecialCreateView.vue')
  },
  {
    path: '/dashboard/drop-specials/:id/edit',
    name: 'DropSpecialEdit',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Drop/Specials/SpecialEditView.vue')
  },
  // DROP ORDERS
  {
    path: '/dashboard/drop-orders',
    name: 'drop-order-list',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/DropOrders/OrderListView')
  },
  {
    path: '/dashboard/drop-orders/:id',
    name: 'drop-order-edit',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/DropOrders/OrderEditView')
  },
  {
    path: '/dashboard/drop-orders/:id/logs',
    name: 'drop-order-log',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/DropOrders/OrderLogs.vue')
  },
  // Referral
  {
    path: '/dashboard/drop-referrals/',
    name: 'DropReferralList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/DropReferral/DropReferralList.vue')
  },
  {
    path: '/dashboard/promo-codes/',
    name: 'DropPromoCodeList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/DropPromoCodes/DropPromoCodeList.vue')
  },
  {
    path: '/dashboard/drop-comments/',
    name: 'DropCommentsList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/DropComments/DropCommentList.vue')
  }
]
